import { __awaiter } from "tslib";
import { LockedDayService } from "@/services/models/schedule/lockedDay";
const moduleLockedDay = {
    namespaced: true,
    state: {
        lockedDay: [],
        loading: false,
    },
    getters: {
        getLockedDay(state) {
            return state.lockedDay;
        },
        getLoading(state) {
            return state.loading;
        },
    },
    mutations: {
        setLockedDay(state, lockedDay) {
            state.lockedDay = lockedDay;
        },
        setLoading(state, loading) {
            state.loading = loading;
        },
    },
    actions: {
        getLockedDay({ commit }) {
            return __awaiter(this, void 0, void 0, function* () {
                commit("setLoading", true);
                const LOCKEDDAY = yield LockedDayService.getByNode(parseInt(localStorage.getItem("stablishment")));
                commit("setLockedDay", LOCKEDDAY);
                commit("setLoading", false);
            });
        },
        getLockedDayByYear({ commit }, year) {
            return __awaiter(this, void 0, void 0, function* () {
                commit("setLoading", true);
                const LOCKEDDAY = yield LockedDayService.getByFindYearAndNode(year, parseInt(localStorage.getItem("stablishment")));
                commit("setLockedDay", LOCKEDDAY);
                commit("setLoading", false);
            });
        },
        getLockedDayInNode({ commit }) {
            return __awaiter(this, void 0, void 0, function* () {
                commit("setLoading", true);
                const LOCKEDDAY = yield LockedDayService.getByNode(parseInt(localStorage.getItem("stablishment")));
                commit("setLockedDay", LOCKEDDAY);
                commit("setLoading", false);
            });
        },
    },
};
export default moduleLockedDay;
